import React from "react";
import {
  Box,
  Container,
  Typography,
  Stack,
  Avatar,
  Grid,
  Divider,
} from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import RocketIcon from "@mui/icons-material/RocketLaunch";
import PeopleIcon from "@mui/icons-material/People";

export default function About() {
  return (
    <Box component="main" sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <Stack spacing={3}>
          <Typography variant="h4" fontWeight={800}>
            About FentrixBank
          </Typography>

          <Typography>
            FentrixBank is a modern digital bank built to deliver fast, secure,
            and accessible financial services. We combine regulatory compliance,
            best-in-class security and a customer-first design to serve retail and
            small business customers globally.
          </Typography>

          <Divider />

          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <Stack spacing={2} alignItems="center">
                <Avatar sx={{ bgcolor: "primary.main", width: 72, height: 72 }}>
                  <BusinessIcon />
                </Avatar>
                <Typography variant="h6" fontWeight={700}>
                  Our Mission
                </Typography>
                <Typography color="text.secondary">
                  To make banking intuitive and secure while enabling global access.
                </Typography>
              </Stack>
            </Grid>

            <Grid item xs={12} md={4}>
              <Stack spacing={2} alignItems="center">
                <Avatar sx={{ bgcolor: "secondary.main", width: 72, height: 72 }}>
                  <RocketIcon />
                </Avatar>
                <Typography variant="h6" fontWeight={700}>
                  Innovation
                </Typography>
                <Typography color="text.secondary">
                  We adopt modern technologies, open APIs and robust analytics to
                  continuously improve the product.
                </Typography>
              </Stack>
            </Grid>

            <Grid item xs={12} md={4}>
              <Stack spacing={2} alignItems="center">
                <Avatar sx={{ bgcolor: "success.main", width: 72, height: 72 }}>
                  <PeopleIcon />
                </Avatar>
                <Typography variant="h6" fontWeight={700}>
                  People First
                </Typography>
                <Typography color="text.secondary">
                  Customer safety, privacy and responsive support are central to our culture.
                </Typography>
              </Stack>
            </Grid>
          </Grid>

          <Divider />

          <Typography variant="body2" color="text.secondary">
            FentrixBank is a registered financial services provider where required by law.
            For corporate information or media inquiries, email corporate@fentrixbank.com.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}